import { RewardVault } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";

export const StartDistributing = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).startDistributing();

export const StopDistributing = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
) =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).stopDistributing();

export const PauserMethods = {
  StartDistributing,
  StopDistributing,
};

export default PauserMethods;
